import React from 'react';
import './Spinner.scss';

const Spinner = () => (
    <div>
        <div className="spinner center">
            <div className="spinner-blade" />
            <div className="spinner-blade" />
            <div className="spinner-blade" />
            <div className="spinner-blade" />
            <div className="spinner-blade" />
            <div className="spinner-blade" />
            <div className="spinner-blade" />
            <div className="spinner-blade" />
            <div className="label">One moment...</div>
        </div>
    </div>
);

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.jsx